export const environment = {
  aodocsBaseUrl: 'https://eu.aodocs.app',
  clientId: 'TBD',
  authRedirectUri: window.location.origin,
  version: '1.0.0',
  production: false,
  backendHost: 'https://doc-viewer-backend-555746129948.europe-west8.run.app',
  useMockBackend: false,
  firebase: {
    apiKey: 'AIzaSyDwIVOXiw6Jl40pZUO0w9nr4FNuKSggbso',
    authDomain: 'tesi-dev-firebase-auth.firebaseapp.com',
    projectId: 'tesi-dev-firebase-auth',
    databaseURL: "https://tesi-dev-firebase-auth-default-rtdb.europe-west1.firebasedatabase.app",
    storageBucket: 'tesi-dev-firebase-auth.firebasestorage.app',
    messagingSenderId: '475386018550',
    appId: '1:475386018550:web:885851ce4bd026418e4ad7',
    measurementId: 'G-B21509EXEV'
}
};
